import React, { useState } from 'react';

import Accordion from '@hpstellar/core/AccordionOld';
import Checkbox from '@hpstellar/core/Checkbox';
import Minus from '@hpstellar/core/Icons/Minus';
import ChevronRight from '@hpstellar/core/Icons/ChevronRight';
import Input from '@hpstellar/core/RangeSlider/components/Input/Input';
import RadioGroup from '@hpstellar/core/RadioGroup';
import Radio from '@hpstellar/core/Radio';
import Ratings from '@hpstellar/core/Ratings';

import LeftRailBanner from './left-rail-banner';

import './vwa-left-menu.less';

// Accessories sub category filter cases
const MONITOR = 1;
const MONITOR_ACCESSORIES = 2;
const ACCESSORIES = 3;

// TODO: maybe host this? not sure if ETR is going to take it on or not
// move this to gql resolver
const getPriceRange = (vanityUrl, facets) => {
    const subCategory = getAccessoriesSubCategory(facets);
    switch (true) {
        case vanityUrl === 'vwa/laptops':
            return [
                {
                    label: 'Under $400',
                    value: '1-400',
                },
                {
                    label: '$400 to $600',
                    value: '400-600',
                },
                {
                    label: '$600 to $800',
                    value: '600-800',
                },
                {
                    label: '$800 to $1000',
                    value: '800-1000',
                },
                {
                    label: '$1000 to $1200',
                    value: '1000-1200',
                },
                {
                    label: '$1200 to $1400',
                    value: '1200-1400',
                },
                {
                    label: 'Over $1400',
                    value: '1400-99999',
                },
            ];
        case vanityUrl === 'vwa/desktops':
            return [
                {
                    label: 'Under $600',
                    value: '1-600',
                },
                {
                    label: '$600 to $800',
                    value: '600-800',
                },
                {
                    label: '$800 to $1000',
                    value: '800-1000',
                },
                {
                    label: '$1000 to $1200',
                    value: '1000-1200',
                },
                {
                    label: '$1200 to $1400',
                    value: '1200-1400',
                },
                {
                    label: 'Over $1400',
                    value: '1400-99999',
                },
            ];
        case vanityUrl === 'vwa/printers':
            return [
                {
                    label: 'Under $100',
                    value: '1-100',
                },
                {
                    label: '$100 to $300',
                    value: '100-300',
                },
                {
                    label: '$300 to $500',
                    value: '300-500',
                },
                {
                    label: 'Over $500',
                    value: '500-99999',
                },
            ];
        case vanityUrl === 'vwa/monitors':
            return [
                {
                    label: 'Under $199',
                    value: '1-199',
                },
                {
                    label: '$200 to $299',
                    value: '200-299',
                },
                {
                    label: '$300 to $399',
                    value: '300-399',
                },
                {
                    label: '$400 to $499',
                    value: '400-499',
                },
                {
                    label: 'Over $500',
                    value: '500-99999',
                },
            ];
        case vanityUrl === 'vwa/business-solutions':
            return [
                {
                    label: 'Under $600',
                    value: '1-600',
                },
                {
                    label: '$600 to $800',
                    value: '600-800',
                },
                {
                    label: '$800 to $1000',
                    value: '800-1000',
                },
                {
                    label: '$1000 to $1200',
                    value: '1000-1200',
                },
                {
                    label: '$1200 to $1400',
                    value: '1200-1400',
                },
                {
                    label: '$1400 to $1600',
                    value: '1400-1600',
                },
                {
                    label: '$1600 to $1800',
                    value: '1600-1800',
                },
                {
                    label: '$1800 to $2000',
                    value: '1800-2000',
                },
                {
                    label: 'Over $2000',
                    value: '2000-99999',
                },
            ];
        case vanityUrl === 'vwa/accessories-88342--1' && subCategory === MONITOR:
            return [
                {
                    label: 'Under $199',
                    value: '1-199',
                },
                {
                    label: '$200 to $299',
                    value: '200-299',
                },
                {
                    label: '$300 to $399',
                    value: '300-399',
                },
                {
                    label: '$400 to $499',
                    value: '400-499',
                },
                {
                    label: 'Over $500',
                    value: '500-99999',
                },
            ];
        case vanityUrl === 'vwa/accessories-88342--1' && subCategory === MONITOR_ACCESSORIES:
            return [
                {
                    label: 'Under $99',
                    value: '1-99',
                },
                {
                    label: '$100 to $199',
                    value: '100-199',
                },
                {
                    label: '$200 to $299',
                    value: '200-299',
                },
                {
                    label: '$300 to $399',
                    value: '300-399',
                },
                {
                    label: 'Over $400',
                    value: '400-99999',
                },
            ];
        case vanityUrl === 'vwa/accessories-88342--1' && subCategory === ACCESSORIES:
            return [
                {
                    label: 'Under $29',
                    value: '1-29',
                },
                {
                    label: '$30 to $59',
                    value: '30-59',
                },
                {
                    label: '$60 to $99',
                    value: '60-99',
                },
                {
                    label: '$100 to $199',
                    value: '100-199',
                },
                {
                    label: 'Over $200',
                    value: '200-99999',
                },
            ];
        default:
            return [
                {
                    label: 'Under $600',
                    value: '0-600',
                },
                {
                    label: '$600 to $1000',
                    value: '600-1000',
                },
                {
                    label: '$1000 to $1500',
                    value: '1000-1500',
                },
                {
                    label: '$1500 and above',
                    value: '1500-99999',
                },
            ];
    }
};

const getAccessoriesSubCategory = facets => {
    const category = facets.find(item => item.key === 'acccat');
    if (!category) return;

    let monitors = false;
    const selected = category.facetValue.filter(item => {
        if (!monitors) {
            monitors = item.urlValue === 'Displays' && item.checked === 'true';
        }
        return item.checked === 'true';
    });

    if (monitors && selected.length === 1) {
        return MONITOR;
    } else if (!monitors && selected.length > 0) {
        return ACCESSORIES;
    }
    return MONITOR_ACCESSORIES;
};

export default function VWALeftMenu({
    facets,
    aligned,
    expandedFacets,
    onSelectFacet,
    sortValues,
    sortValue,
    onSort,
    vanityUrl,
    filters,
    presetRange,
    setPresetRange,
}) {
    const [range, setRange] = useState(['', '']);
    const expanded = expandedFacets.reduce((a, b) => ({ ...a, [b]: true }), {});

    const isValid = range[0] >= 0 && range[1] > 0 && range[0] < range[1];

    const onSubmitRange = () => {
        const rangeValue = range.join('-');
        if (!isValid || (filters.Price && filters.Price[rangeValue])) return;
        setPresetRange(-1);
        onSelectFacet('Price', rangeValue)();
    };

    const onSelectPresetRange = (value, i) => {
        setPresetRange(presetRange === i ? -1 : i);
        setRange(['', '']);
        onSelectFacet('Price', value)();
    };

    return (
        <div className="leftMenu">
            {sortValues && (
                <Accordion className="mobileSort" title="SORT BY" defaultOpen>
                    <RadioGroup value={sortValue} onChange={value => onSort({ value })}>
                        {sortValues.map(({ title, key }) => (
                            <Radio label={title} value={key} variant="list" />
                        ))}
                    </RadioGroup>
                </Accordion>
            )}

            <Accordion title="PRICE RANGE" defaultOpen>
                <div className="priceRange">
                    {/* TODO: input validation */}
                    <Input
                        className="input"
                        inputProps={{
                            placeholder: 'Min',
                        }}
                        onChange={e => setRange([e.target.value, range[1]])}
                        symbol="$"
                        symbolPosition="left"
                        type="number"
                        value={range[0]}
                    />
                    <span className="divider">
                        <Minus size="s" />
                    </span>
                    <Input
                        className="input"
                        inputProps={{
                            placeholder: 'Max',
                        }}
                        onChange={e => setRange([range[0], e.target.value])}
                        symbol="$"
                        symbolPosition="left"
                        type="number"
                        value={range[1]}
                    />
                    <button className="button" onClick={onSubmitRange} type="button">
                        <ChevronRight size="s" color="white" />
                    </button>
                </div>
                <div className="presetRange">
                    {getPriceRange(vanityUrl, facets).map((preset, i) => (
                        <Checkbox
                            key={`preset-range-${i}`}
                            label={preset.label}
                            checked={i === presetRange}
                            onToggle={() => onSelectPresetRange(preset.value, i)}
                            aligned="left"
                        />
                    ))}
                </div>
            </Accordion>
            {facets
                .sort((a, b) => parseInt(a.displaySequence, 10) < parseInt(b.displaySequence, 10))
                .map(({ tooltip, displayName, facetValue, key: facet }, idx) => (
                    <Accordion
                        key={`facet_${idx}`}
                        title={displayName}
                        enableTooltip={tooltip}
                        tooltipProps={{ description: tooltip }}
                        defaultOpen={expanded[displayName]}
                    >
                        {facetValue.map(({ displayName: label, checked, count, urlValue }, idx) => (
                            <Checkbox
                                className={facet === 'rating' ? 'ratingCheckbox' : ''}
                                key={`${displayName}-${idx}`}
                                label={facet === 'rating' ? undefined : label}
                                checked={checked === 'true'}
                                counter={count}
                                onToggle={onSelectFacet(facet, urlValue)}
                                readOnly={count === 0}
                                aligned={aligned}
                            >
                                {facet === 'rating' && (
                                    <Ratings
                                        className="filterRating"
                                        score={label === 'None' ? 0 : label.substring(0, 1)}
                                        showScore={false}
                                    />
                                )}
                            </Checkbox>
                        ))}
                    </Accordion>
                ))}
            <LeftRailBanner />
        </div>
    );
}
